import fetch from '@/utils/request';
import { sift_query_list } from 'utils/sift';
import { deepCopy, formatDate } from 'utils/index';

// ! 问卷列表
export function apiGetSurveyPaperList(data) {
	return fetch({
		url: '/call/survey/paper/list.json',
        method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 获取问卷配置信息
export function apiGetSurveyPaperInfo(data){
    return fetch({
        url: '/call/survey/paper/getPaper.json',
        method: 'post',
		data: data,
		contentType: 'formData'
    });
}

// ! 更新问卷配置
export function apiPostSurveyPaperCreateUpdate(data){
    return fetch({
        url: '/call/survey/paper/createOrUpdatePaperQuick.json',
        method: 'post',
		data: data,
    });
}

// ! 删除问卷配置
export function apiPostSurveyPaperDelete(data){
    return fetch({
        url: '/call/survey/paper/delPaper.json',
        method: 'post',
		data: data,
		contentType: 'formData'
    });
}

// ! 保存问卷
export function apiSaveSurveyPaper(data){
    return fetch({
        url: '/call/survey/save/paper.json',
        method: 'post',
		data: data,
		contentType: 'formData'
    });
}
// ! 问卷结果查询
export function apigetSurveyPaperResult(data){
    return fetch({
        url: '/call/survey/save/results.json',
        method: 'post',
		data: data,
		contentType: 'formData'
    });
}
//复制问卷
export function copyBreathPaperItem(data){
	return fetch({
	    url: '/call/survey/paper/copyPaper.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}

/*********** 主题分类 ************/
// 列表查询
export function getBreathThemeTypesList(data){
	return fetch({
	    url: '/call/ob/campaign/list.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
// 新增
export function addBreathThemeTypesList(data){
	return fetch({
	    url: '/call/ob/campaign/add.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//编辑
export function editBreathThemeTypesList(data){
	return fetch({
	    url: '/call/ob/campaign/edit.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//删除
export function deleteBreathThemeTypesList(data){
	return fetch({
	    url: '/call/ob/campaign/delete.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}


/*********** 主题 ************/
// 列表查询
export function getBreathThemeList(data){
	return fetch({
	    url: '/call/ob/subject/list.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//新增
export function addBreathThemeList(data){
	return fetch({
	    url: '/call/ob/subject/add.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//修改
export function editBreathThemeList(data){
	return fetch({
	    url: '/call/ob/subject/edit.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//删除
export function deleteBreathThemeList(data){
	return fetch({
	    url: '/call/ob/subject/delete.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//查询主题详情
export function getBreathThemeListInfo(data){
	return fetch({
	    url: '/call/ob/subject/get.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//复制主题
export function copyBreathThemeItem(data){
	return fetch({
	    url: '/call/ob/subject/copySubject.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}

/* *************原始数据******************* */
//批量获取原始数据列表
export function getBreathdataBaseList(data){
	return fetch({
	    url: '/call/ob/original/getBatchInfoList.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//原始数据列表查询
export function getBreathdataBaseInfoList(data){
	return fetch({
	    url: '/call/ob/original/list.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//原始数据删除
export function deleteBreathdataBaseInfoList(data){
	return fetch({
	    url: '/call/ob/original/delete.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
// 获取所有用户信息
export function getAllPlatformUserList(data){
	return fetch({
	    url: '/ocs-auth/user/manage/select',
	    method: 'post',
		data: data
	});
	
}
//获取原始数据字段展示
export function getBreathdataBaseColumnList(data){
	return fetch({
	    url: '/call/ob/original/columnList.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//修改原始数据
export function updateBreathdataBaseColumnList(data){
	return fetch({
	    url: '/call/ob/original/updateColumnData.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//数据文件列表查询
export function getBreathdataBaseFileList(data){
	return fetch({
	    url: '/call/ob/original/batchList.json',
	    method: 'post',
		data: sift_query_list(data),
		contentType: 'formData'
	});
	
}
//上传原始数据第一步
export function stepFirstBreathdataBaseList(data){
	return fetch({
	    url: '/call/ob/original/uploadOriginalBatch.json',
	    method: 'post',
		data: data
	});
	
}
//上传原始数据第二步
export function stepSecondBreathdataBaseList(data){
	return fetch({
	    url: '/call/ob/original/createOriginalBatch.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//更新数据文件名称
export function updateBreathdataBaseListRowName(data){
	return fetch({
	    url: '/call/ob/original/updateBatch.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}


/* **************外呼任务************** */
//数据列表
export function getBreathTaskList(data){
	data = deepCopy(data);
	if(data.date1) {
		data['startObTime'] = formatDate(data.date1[0], 'YYYY-MM-DD HH:mm:ss');
		data['endObTime'] = formatDate(data.date1[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date2) {
		data['startAppoinObTime'] = formatDate(data.date2[0], 'YYYY-MM-DD HH:mm:ss');
		data['endAppoinObTime'] = formatDate(data.date2[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date3) {
		data['startLastDialTime'] = formatDate(data.date3[0], 'YYYY-MM-DD HH:mm:ss');
		data['endLastDialTime'] = formatDate(data.date3[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date4) {
		data['startCreateTime'] = formatDate(data.date4[0], 'YYYY-MM-DD HH:mm:ss');
		data['endCreateTime'] = formatDate(data.date4[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.taskStatus){
		data.taskStatus = data.taskStatus.join(',')
	}
	delete data.date1;
	delete data.date2;
	delete data.date3;
	delete data.date4;
	return fetch({
	    url: '/call/ob/task/list.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}

//分配任务
export function toSpecifyBreathTask(data, queryList){
	data = deepCopy(data);

	data = Object.assign(data, queryList);

	if(data.date1) {
		data['startObTime'] = formatDate(data.date1[0], 'YYYY-MM-DD HH:mm:ss');
		data['endObTime'] = formatDate(data.date1[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date2) {
		data['startAppoinObTime'] = formatDate(data.date2[0], 'YYYY-MM-DD HH:mm:ss');
		data['endAppoinObTime'] = formatDate(data.date2[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date3) {
		data['startLastDialTime'] = formatDate(data.date3[0], 'YYYY-MM-DD HH:mm:ss');
		data['endLastDialTime'] = formatDate(data.date3[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date4) {
		data['startCreateTime'] = formatDate(data.date4[0], 'YYYY-MM-DD HH:mm:ss');
		data['endCreateTime'] = formatDate(data.date4[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.taskStatus){
		data.taskStatus = data.taskStatus.join(',')
	}
	delete data.date1;
	delete data.date2;
	delete data.date3;
	delete data.date4;

	delete data.pageSize;
	return fetch({
	    url: '/call/ob/task/assignBatch.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
// 更改任务状态
export function updateBreathTaskStatus(data){
	return fetch({
	    url: '/call/ob/task/changeTaskStatusBatch.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
// 重开任务
export function reOpenTaskBreathTask(data){
	return fetch({
	    url: '/call/ob/task/reOpenTask.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//生成外呼任务
export function createTaskBreathTask(data){
	return fetch({
	    url: '/call/ob/task/createTask.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//自动执行外呼传主题（下一个未执行任务）传taskid 当前任务详情
export function toAutoTaskBreathTask(data){
	return fetch({
	    url: '/call/ob/task/execTask.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}

//查询生成任务的数量
export function getTaskBreathTaskNumber(data){
	return fetch({
	    url: '/call/ob/original/getCreatedTaskCount.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//关闭任务
export function closeTaskBreathTaskInfo(data){
	return fetch({
	    url: '/call/ob/task/closeTask.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//查询任务分析表
export function getTaskBreathTaskAnalyese(data){
	return fetch({
	    url: '/call/ob/report/iamList.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//回访历史
export function getTaskBreathTaskLogList(data){
	return fetch({
	    url: '/call/ob/task/logList.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//获取外呼数据详情
export function getTaskBreathTaskInfos(data){
	return fetch({
	    url: '/call/ob/original/getOriginal.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//完成任务
export function finishTaskBreathTaskInfos(data){
	return fetch({
	    url: '/call/ob/task/finishTask.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//预约下次外呼任务
export function appointTaskBreathTaskInfos(data){
	return fetch({
	    url: '/call/ob/task/appoinObTask.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
/* ************执行外呼************** */
//外呼列表
export function getTaskBreathCalloutList(){
	return fetch({
	    url: '/call/ob/task/getSubjectTaskList.json',
	    method: 'post',
	});
	
}



/* ***********外呼状态*********** */
//列表
export function getBreathTaskStatus(data){
	return fetch({
	    url: '/call/ob/status/list.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
// 新增
export function addBreathTaskStatus(data){
	return fetch({
	    url: '/call/ob/status/add.json',
	    method: 'post',
		data: sift_query_list(data),
		contentType: 'formData'
	});
	
}
//修改
export function editBreathTaskStatus(data){
	return fetch({
	    url: '/call/ob/status/edit.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//删除
export function deleteBreathTaskStatus(data){
	return fetch({
	    url: '/call/ob/status/delete.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
//完成外呼推线索
export function finishBreathTaskToSendData(data){
	return fetch({
	    url: '/imcustom/sys/lead/webService/receiveCallback.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
/* ***********外呼报表****************** */
// 列表
export function getBreathreportFormList(data){
	data = deepCopy(data);
	if(data.taskStatus){
		data.taskStatus = data.taskStatus.join(',');
	}
	if(data.date1) {
		data['startObTime'] = formatDate(data.date1[0], 'YYYY-MM-DD HH:mm:ss');
		data['endObTime'] = formatDate(data.date1[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date2) {
		data['startAppoinObTime'] = formatDate(data.date2[0], 'YYYY-MM-DD HH:mm:ss');
		data['endAppoinObTime'] = formatDate(data.date2[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date3) {
		data['startLastDialTime'] = formatDate(data.date3[0], 'YYYY-MM-DD HH:mm:ss');
		data['endLastDialTime'] = formatDate(data.date3[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date4) {
		data['startCreateTime'] = formatDate(data.date4[0], 'YYYY-MM-DD HH:mm:ss');
		data['endCreateTime'] = formatDate(data.date4[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.date1;
	delete data.date2;
	delete data.date3;
	delete data.date4;
	return fetch({
	    url: '/call/ob/report/list.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
	
}
// 导出
export function exportBreathreportFormList(data){
	data = deepCopy(data);
	if(data.date1) {
		data['startObTime'] = formatDate(data.date1[0], 'YYYY-MM-DD HH:mm:ss');
		data['endObTime'] = formatDate(data.date1[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date2) {
		data['startAppoinObTime'] = formatDate(data.date2[0], 'YYYY-MM-DD HH:mm:ss');
		data['endAppoinObTime'] = formatDate(data.date2[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date3) {
		data['startLastDialTime'] = formatDate(data.date3[0], 'YYYY-MM-DD HH:mm:ss');
		data['endLastDialTime'] = formatDate(data.date3[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.date4) {
		data['startCreateTime'] = formatDate(data.date4[0], 'YYYY-MM-DD HH:mm:ss');
		data['endCreateTime'] = formatDate(data.date4[1], 'YYYY-MM-DD HH:mm:ss');
	}
	if(data.taskStatus){
		data.taskStatus = data.taskStatus.join(',')
	}
	delete data.date1;
	delete data.date2;
	delete data.date3;
	delete data.date4;
	return fetch({
	    url: '/call/ob/report/export.json',
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}
//下载报表
export function downloadBreathreportFormByName(data){
	return fetch({
	    url: `/call/ob/report/file/download/${data}`,
	    method: 'get',
		responseType: 'blob'
	});
}
//外呼计数
export function getCalloutNumber(data){
	return fetch({
	    url: `/call/ob/task/calcObCount.json`,
	    method: 'post',
		data:data,
		contentType: 'formData'
	});
}

// 话务Dashboard
export function getPostImCustomDashboard(){
	return fetch({
	    url: `/imcustom/sys/report/dashboard.json`,
	    method: 'post'
	});
}

// 获取api规则列表
export function getPostCallApiRuleList(data){
	return fetch({
	    url: `/call/ob/original/subject/rule/list.json`,
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// 新增api规则
export function getPostCallApiRuleCreate(data){
	return fetch({
	    url: `/call/ob/original/subject/rule/add.json`,
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// 修改api规则
export function getPostCallApiRuleUpdate(data){
	return fetch({
	    url: `/call/ob/original/subject/rule/edit.json`,
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// 删除api规则
export function getPostCallApiRuleDelete(data){
	return fetch({
	    url: `/call/ob/original/subject/rule/delete.json`,
	    method: 'post',
		data: data,
		contentType: 'formData'
	});
}

//获取虚拟号
export function getVirtualPhoneNumberUrl(url,data){
	return fetch({
	    url: `/${url}`,
	    method: 'get',
		params: data,
		baseUrlType: 'virtualHost'
	})
}
// 获取页签列表
export function apiGetTabList(params){
	return fetch({
	    url: `/ocs-dynamic-form/form/collaboration/get/tab`,
	    method: 'get',
		params: params
	});
}

// 获取表头列表
export function apiGetTableHeaderList(params){
	return fetch({
	    url: `/ocs-dynamic-form/form/collaboration/get/tableHeader`,
	    method: 'get',
		params: params
	});
}

// 获取表数据列表
export function apiPostTableList(data){
	return fetch({
	    url: `/ocs-dynamic-form/form/collaboration/get/tableBody`,
	    method: 'post',
		data: data
	});
}